module.exports = __webpack_public_path__ + "img/telegram.fd9fedea.svg";